import type { Locale } from "date-fns";
import { cs, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";

export const useDateFnsLocale = (): Locale => {
	const { i18n } = useTranslation();

	return i18n.language?.toLowerCase().startsWith("en") ? enUS : cs;
};
